import type {
  AgentBuilderRequest,
  AgentBuilderResponse,
  DataResponse,
  FlowBuilderRequest,
  FlowBuilderResponse,
} from "@/types";
import { api } from "../api";

export const builderService = {
  buildAgent: (data: AgentBuilderRequest) => api.post<DataResponse<AgentBuilderResponse>>("/builder/agent", data),

  buildFlow: (data: FlowBuilderRequest) => api.post<DataResponse<FlowBuilderResponse>>("/builder/flow", data),
};
